module.exports = __webpack_public_path__ + "img/cover2.e0f6a7ca.png";